const baseApi = {
  applications: 'applications',
  ccConfig: 'contact-center-config',
  ccAuthority: 'contact-center-authority',
  dynamicSetup: 'dynamic-setup-bff',
  i18n: 'i18n',
  ordering: 'ordering',
  numbers: 'numbers',
  pbx: 'pbx',
  unifiedAdmin: 'unified-admin',
  adminCopilot: 'admin-copilot',
  v5: 'v5',
  version: 'v1',
  billingPortalBff: 'billing-portal-bff',
  productExploration: 'product-exploration-bff',
}

export default baseApi
